import api from '../../services/api';
import BaseService from '../BaseService';

class ImportacaoArquivosService extends BaseService {
    constructor() {
        super('suporte/importacao_padronizada');
    }

    /**
     * Valida o arquivo CSV enviado.
     * @param {FormData} formData - Deve conter: arquivo_csv, programa_id, area, dry_run, strict_custom_fields
     */
    validar(formData) {
        return api.post(`${this.resource}validar/`, formData);
    }

    /**
     * Confirma (executa) a importação de um job já validado.
     * @param {{ job_id: number }} data
     */
    confirmar(data) {
        return api.post(`${this.resource}confirmar/`, data);
    }

    /**
     * Lista o histórico de jobs com filtros opcionais.
     * @param {Object} params - programa_id, area, status, data_de, data_ate, nome_arquivo, somente_com_erro, criado_por, page
     */
    listarJobs(params) {
        return api.get(`${this.resource}jobs/`, { params });
    }

    /**
     * Retorna o detalhe completo de um job, incluindo erros por linha.
     * @param {number} id
     */
    detalheJob(id) {
        return api.get(`${this.resource}jobs/${id}/`);
    }

    /**
     * Retorna erros de um job de forma paginada (endpoint dedicado).
     * @param {number} jobId
     * @param {number} page        – página (default 1)
     * @param {number} pageSize    – itens por página (default 50, max 200)
     * @param {string} [severidade] – 'erro' | 'warning' | '' (todos)
     */
    errosPaginados(jobId, page = 1, pageSize = 50, severidade = '') {
        const params = { page, page_size: pageSize };
        if (severidade) params.severidade = severidade;
        return api.get(`${this.resource}jobs/${jobId}/erros/`, { params });
    }

    /**
     * Baixa o template CSV de exemplo para a área informada.
     * @param {string} area - pacientes | medicos | prestadores | agendamentos
     */
    downloadTemplate(area) {
        return api.get(`${this.resource}template/`, {
            params: { area },
            responseType: 'blob',
        });
    }

    /**
     * Baixa o guia de documentação (markdown) para a área informada.
     * @param {string} area - pacientes | medicos | prestadores | agendamentos
     */
    downloadDocumentacao(area) {
        return api.get(`${this.resource}documentacao/`, {
            params: { area },
            responseType: 'blob',
        });
    }
}

const importacaoArquivosService = new ImportacaoArquivosService();
export default importacaoArquivosService;
